import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-taskCarrier-lookup',
  templateUrl: './micro-taskCarrier-lookup.component.html'
})
export class MicroTaskCarrierLookupComponent  {

  @Input()
  taskCarrierId:any;
}
